<template>
    <DModal
        :show="showModal"
        :title="__(`contracts.pricings.modal.title`)"
        @close="closeModal"
    >
        <DFieldLoading
            v-if="isLoading"
            :is-loading="isLoading"
            is-big
            class="my-4 d-flex justify-content-center"
        />
        <DCard
            v-else
            padding
        >
            <DFormRow :label="__('contracts.pricings.modal.total')">
                {{ stats.total }}
            </DFormRow>
            <DFormRow :label="__('contracts.pricings.modal.sent')">
                {{ stats.sent }}
            </DFormRow>
            <DFormRow :label="__('contracts.pricings.modal.completed')">
                {{ stats.completed }}%
            </DFormRow>
            <DFormRow :label="__('contracts.pricings.modal.status')">
                <DTag
                    :label="__('contracts.pricings.modal.status_values.' + stats.status)"
                    :color="getTagColor(stats.status)"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { ref } from 'vue'

import { route } from '~@/Composables/route'
import DFieldLoading from '~@/Components/Common/DFieldLoading'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    pricingUpload: {
        type: Number,
        default: null
    }
})

const isLoading = ref(true)

const stats = ref({
    total: null,
    sent: null,
    completed: null,
    status: null
})

const getTagColor = (status) => {
    if (status === 'completed') {
        return 'success'
    }

    return 'secondary'
}

const setData = () => {
    window.axios.get(route('contracts.pricing.email-stats', props.pricingUpload))
        .then(response => {
            const data = response.data
            stats.value.total = data.total
            stats.value.sent = data.sent
            stats.value.completed = data.completed
            stats.value.status = data.status
            isLoading.value = false
        })
}

setData()

const interval = setInterval(setData, 10000)

const closeModal = () => {
    clearInterval(interval)
}
</script>
